<template>
  <div>
    <span class="pre-span" :style="{ width: pre_item.width + 'px' }"></span>
  </div>
</template>

<script>
  //
  export default {
    name: "hj-span",
    data() {
      return {
        pre_item: {}
      }
    },
    props: {
      inData: {
        type: String,
        default: ''
      }
    },
    created() {
      this.pre_item = {};
      this.pre_item = JSON.parse(this.inData);
      // console.log(this.pre_item);
    },
    activated: function() {
      // console.log('keep-alive 组件激活时调用 hj-input激活');
      // console.log(this.inData);
      this.pre_item = {};
      this.pre_item = JSON.parse(this.inData);
      // console.log(this.pre_item);
    },
    deactivated: function() {
      // console.log('keep-alive 组件激活时调用 hj-input停用');
      this.pre_item = {};
    },
    methods: {
    }
  }
</script>

<style scoped="scoped">
  .pre-span {
    display: inline-block;
    vertical-align: middle;
    min-width: 1px;
  }

</style>
